export enum ProductClassStatus {
    Draft = 0,
    Active = 1,
    Archived = 2
}